import { render, staticRenderFns } from "./ViewTextList.vue?vue&type=template&id=bf7aed70"
import script from "./ViewTextList.vue?vue&type=script&lang=js"
export * from "./ViewTextList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports